import React from "react";
import LoadingIcon from "../icons/LoadingIcon";
import clsx from "clsx";

const PrimaryButton = ({
  disabled,
  loading,
  type = "submit",
  children,
  startIcon,
  ...others
}) => {
  // outline outline-1 outline-offset-[-2px] outline-white/10
  // !outline-primaryDisabledBorder
  return (
    <button
      disabled={disabled || loading}
      type={type}
      className={clsx(
        "bg-primary hover:bg-primaryHover text-white w-full px-4 py-[10px] shadow-sm rounded-lg flex items-center justify-center text-base font-semibold leading-6",
        {
          "cursor-progress": loading,
          "cursor-not-allowed !bg-primaryDisabledBg !text-primaryDisabledText":
            disabled,
        }
      )}
      {...others}
    >
      <div className="flex items-center gap-2">
        {loading ? <LoadingIcon /> : startIcon}
        <span>{children}</span>
      </div>
    </button>
  );
};

export default PrimaryButton;
